import './footer.css'

export default function Footer() {
    return (
        <div className="footer">
            <p>© 2024 romtuck</p>
        </div>
    );
}